/* CRG wiring diagram intake. Prefill, conditional fields, client-side image downscale, multipart POST. */
(function () {
  var MAX_EDGE = 1600, JPEG_Q = 0.82;

  document.querySelectorAll('.crg-wr__form').forEach(init);

  function init(form) {
    var endpoint = form.dataset.endpoint || '';
    var maxBytes = (parseInt(form.dataset.maxmb, 10) || 15) * 1024 * 1024;
    var root = form.closest('.crg-wr');
    var errBox = form.querySelector('[data-form-error]');
    var sizeBox = form.querySelector('[data-size-readout]');
    var success = root.querySelector('[data-success]');
    var btn = form.querySelector('.crg-wr__submit');

    wireConditionals(form);
    form.addEventListener('change', function (e) {
      if (e.target.type === 'file') showSize(form, sizeBox, maxBytes);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hide(errBox);

      if (form.querySelector('[name="company_website"]').value) { done(); return; } // trap

      var bad = firstInvalid(form);
      if (bad) {
        fail(errBox, 'Please complete the highlighted question.');
        // The consent tick box sits in its own wrapper, outside any fieldset, so closest()
        // used to come back null here and throw before the field could be focused.
        var box = bad.closest('.crg-wr__f, fieldset, .crg-wr__consent') || bad;
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        bad.focus({ preventScroll: true });
        return;
      }
      if (!endpoint) { fail(errBox, fallbackMsg()); return; }

      busy(true);
      buildPayload(form).then(function (fd) {
        var total = 0;
        fd.forEach(function (v) { if (v && v.size) total += v.size; });
        if (total > maxBytes) {
          busy(false);
          fail(errBox, 'Your files add up to ' + mb(total) + 'MB, which is over the ' + mb(maxBytes) +
            'MB limit. Try fewer photos, or ' + fallbackMsg());
          return;
        }
        return fetch(endpoint, { method: 'POST', body: fd }).then(function (r) {
          busy(false);
          if (!r.ok) throw new Error('HTTP ' + r.status);
          done();
        });
      }).catch(function () {
        busy(false);
        fail(errBox, 'That did not go through. ' + fallbackMsg());
      });
    });

    function busy(on) {
      btn.disabled = on;
      btn.querySelector('[data-label]').hidden = on;
      btn.querySelector('[data-spinner]').hidden = !on;
    }
    function done() {
      form.hidden = true;
      if (sizeBox) sizeBox.hidden = true;
      success.hidden = false;
      success.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function fallbackMsg() {
      return 'please email your answers to info@caferacergarageshop.com and we will pick it up.';
    }
  }

  /* ---------- conditional questions ---------- */
  function wireConditionals(form) {
    var triggers = form.querySelectorAll('[data-toggle]');
    triggers.forEach(function (t) {
      t.addEventListener('change', function () { apply(form); });
    });
    apply(form);
  }
  function apply(form) {
    form.querySelectorAll('[data-show-when]').forEach(function (box) {
      var parts = box.dataset.showWhen.split('=');
      var key = parts[0], want = parts.slice(1).join('=');
      var trig = form.querySelector('[data-toggle="' + key + '"]');
      // want may list several values separated by |, since one block can hang off more than one answer
      var on = !!trig && want.split('|').indexOf(trig.value) !== -1;
      box.hidden = !on;
      // NWT 2026-10-26: "not really an option, the info is available". No waivers now,
      // so a question that is on screen is a question that has to be answered.
      box.querySelectorAll('[data-cond-required]').forEach(function (f) {
        if (on) { f.setAttribute('required', ''); }
        else { f.removeAttribute('required'); f.value = ''; }
      });
    });

  }

  /* ---------- validation ---------- */
  function firstInvalid(form) {
    var fields = form.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (f.name === 'company_website') continue;
      if (f.closest('[hidden]')) continue;
      f.classList.remove('is-bad');
      if (!f.checkValidity()) { f.classList.add('is-bad'); return f; }
    }
    return null;
  }

  /* ---------- payload, with images downscaled ---------- */
  function buildPayload(form) {
    var fd = new FormData();
    var jobs = [];
    form.querySelectorAll('input, select, textarea').forEach(function (f) {
      if (!f.name || f.name === 'company_website') return;
      if (f.type === 'file') {
        Array.prototype.forEach.call(f.files || [], function (file) {
          jobs.push(shrink(file).then(function (out) { fd.append(f.name, out, out.name); }));
        });
      } else if (!f.closest('[hidden]')) {
        // A checkbox carries its value whether or not it is ticked, so asking the
        // element for .value alone reported every waiver as ticked.
        if (f.type === 'checkbox' || f.type === 'radio') { if (f.checked) fd.append(f.name, f.value); }
        else fd.append(f.name, f.value);
      }
    });
    fd.append('submitted_at', new Date().toISOString());
    fd.append('page_url', location.href);
    return Promise.all(jobs).then(function () { return fd; });
  }

  function shrink(file) {
    if (!/^image\//.test(file.type)) return Promise.resolve(file);
    return new Promise(function (resolve) {
      var img = new Image(), url = URL.createObjectURL(file);
      img.onload = function () {
        var s = Math.min(1, MAX_EDGE / Math.max(img.width, img.height));
        if (s === 1 && file.size < 900 * 1024) { URL.revokeObjectURL(url); return resolve(file); }
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(function (b) {
          URL.revokeObjectURL(url);
          if (!b || b.size >= file.size) return resolve(file);
          resolve(new File([b], file.name.replace(/\.(png|heic|heif|webp|jpeg|jpg)$/i, '') + '.jpg',
            { type: 'image/jpeg' }));
        }, 'image/jpeg', JPEG_Q);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  /* ---------- helpers ---------- */
  function showSize(form, box, maxBytes) {
    if (!box) return;
    var n = 0, bytes = 0;
    form.querySelectorAll('input[type=file]').forEach(function (f) {
      Array.prototype.forEach.call(f.files || [], function (x) { n++; bytes += x.size; });
    });
    if (!n) { box.hidden = true; return; }
    box.hidden = false;
    box.textContent = n + (n === 1 ? ' file' : ' files') + ', about ' + mb(bytes) +
      'MB before compression. Photos get shrunk automatically.';
    box.classList.toggle('is-over', bytes > maxBytes * 2.5);
  }
  function mb(b) { return (b / 1024 / 1024).toFixed(1); }
  function fail(box, msg) { if (box) { box.textContent = msg; box.hidden = false; box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }
  function hide(box) { if (box) box.hidden = true; }
})();
